import { progressApi } from "utilities/Axios";
export const getAllHealth = () => {
  return progressApi.get("/Health/GetAll");
};

export const refreshHealth = (id: any) => {
  return progressApi.get("/Health/Get" + `?type=${id}`);
};
